import React, { memo } from 'react';
import { Typography, Box } from '@mui/material';
import { Link as LinkIcon } from '@mui/icons-material';
import { KnowledgeItem } from '../../../types';
import ItemViewModal from '../../../shared/components/ItemViewModal';
import MarkdownContent from '../../../shared/components/MarkdownContent';
import CopyIconButton from '../../../shared/components/CopyIconButton';

interface KnowledgeViewModalProps {
  open: boolean;
  onClose: () => void;
  item: KnowledgeItem | null;
}

const KnowledgeViewModal: React.FC<KnowledgeViewModalProps> = ({
  open,
  onClose,
  item,
}) => {
  if (!item) return null;

  return (
    <ItemViewModal
      open={open}
      onClose={onClose}
      icon={<LinkIcon />}
      title="Knowledge Item Details"
      color="primary"
      rank={item.rank}
      actions={
        <CopyIconButton
          text={item.summary}
          tooltip="Copy summary"
          sx={{ opacity: 0.7, '&:hover': { opacity: 1 } }}
        />
      }
    >
      <Box sx={{ mb: 3 }}>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          Summary
        </Typography>
        <MarkdownContent content={item.summary} accentColor="primary" />
      </Box>

      <Box sx={{ mb: 2 }}>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          Knowledge Base
        </Typography>
        <Typography variant="body2" color="text.primary">
          {item.knowledge_base_id}
        </Typography>
      </Box>

      <Box>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          Item ID
        </Typography>
        <Typography variant="body2" color="text.primary" sx={{ fontFamily: 'monospace' }}>
          {item.knowledge_item_id}
        </Typography>
      </Box>
    </ItemViewModal>
  );
};

export default memo(KnowledgeViewModal);